<template>
  <div class="chuangguan" :class="ifMobile ? 'mobile' : 'comp'">
    <div class="index">
      <div class="title">选修附加课</div>
      <div class="lesson-wrap">
        <div
          class="lesson-item"
          :class="item.stars > 0 ? '' : 'gray'"
          v-if="user && item.课程关联 <= user.current_lesson_id"
          v-for="item in lessonList"
          :key="item._id"
          @click="toUrl(item.课程链接, item.课程关联 > user.current_lesson_id)"
        >
          <div class="lesson-img">
            <img :src="imgs[`img${getRandomNum()}`]" alt="" />
          </div>
          <div class="lesson-info">
            <div class="lesson-name">{{ item.课程名称 }}{{ item.stars > 0 ? '' : '（未完成）' }}</div>
            <div class="lesson-desc">
              <div class="lesson-type">【{{ item.课程类型[0] }}】-{{ item.课程标签[0] }}</div>
              <!-- <div class="lesson-time">
                <span></span>
                <span></span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="menu">
      <div class="menu-bg">
        <div class="menu-content">
          <div>选修附加课主要解锁途径：</div>
          <br />
          <div>1、当达成一定条件时，会解锁额外的精华课程（开小灶的精品课程哦！）</div>
          <div>2、根据你的技能雷达的情况下，挑选合适你发展的课程（专属的哦！）</div>
          <div>3、外部引进的非常值得一看的培训或分享。</div>
          <br />
          <div>选修课有时效的哦，过期不学习，你会失去这个机会的。</div>
        </div>
        <!-- <div class="menu-button-wrap">
          <div class="menu-button" @click="routerTo('/chuangguanInfo')">我的</div>
          <div class="menu-button" @click="routerTo('/chuangguan')">技能通关</div>
          <div class="menu-button">选修课表</div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
const img1 = require('./img/0.png')
const img2 = require('./img/1-1.png')
const img3 = require('./img/1-2.png')
const img4 = require('./img/2-1.png')
const img5 = require('./img/2-2.png')
const img6 = require('./img/3-1.png')
const img7 = require('./img/3-2.png')
export default {
  data() {
    return {
      imgs: { img2, img3, img4, img5, img1, img6, img7 },
      ifMobile: false,
      lessonList: [],
      user: null,
    }
  },
  methods: {
    toUrl(url, finished = false) {
      if (finished) {
        return this.$alert('您还未解锁', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        return
      }
      window.open(url, '_blank')
    },
    getRandomNum() {
      return Math.ceil(Math.random() * 7)
    },
    async getData() {
      const { data } = await app.service('misc').getPlusLessons({ tel: app.user.个人手机 || app.user.工作手机 || '' })
      this.lessonList = data
      console.log(data)
    },
    async getUserInfo() {
      const { data } = await app.service('misc').getLessonMember({ tel: app.user.个人手机 || app.user.工作手机 || '' })
      this.user = data
      console.log(data)
    },
    routerTo(path) {
      this.$router.push(path)
    },
  },
  async mounted() {
    this.ifMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
    await this.getUserInfo()
    await this.getData()
  },
}
</script>
<style scoped>
.chuangguan {
  position: relative;
}
.comp .index {
  padding: 40px 20px;
  padding-bottom: 260px;
}
.index {
  background: linear-gradient(90deg, #a283a5 0%, #e8b7c7 29%, #e8b7c7 45%, #5e4677 100%)!important;
}
.lesson-wrap {
  width: 100%;
  position: relative;
}
.lesson-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
  filter: drop-shadow(2px 4px 6px rgba(100, 100, 100));
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  padding-bottom: 20px;
}
.gray {
  filter: grayscale(1) drop-shadow(2px 4px 6px rgba(100, 100, 100));
}
.lesson-img {
  width: 40px;
  height: 40px;
  margin-right: 20px;
  flex-shrink: 0;
}
.lesson-img img {
  width: 100%;
  height: 100%;
  display: block;
}
.title {
  text-align: center;
  font-size: 24px;
  color: #fff;
  font-weight: 600;
  margin-bottom: 40px;
}
.lesson-info {
  color: #fff;
  flex-grow: 1;
}
.lesson-name {
  font-size: 18px;
  line-height: 30px;
  font-weight: 600;
}
.lesson-desc {
  font-size: 16px;
}
.menu {
  width: 500px;
  position: fixed;
  bottom: 48px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 0.6);
  padding: 10px;
  border-radius: 8px;
  color: #fff;
}
.menu-bg {
  width: 100%;
  height: 100%;
  background-color: rgb(151, 101, 143, 0.8);
  border-radius: 8px;
  padding: 15px;
}
.menu-content {
  font-size: 14px;
  color: #fff;
}
.menu-button-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.menu-button {
  background-color: rgb(90, 67, 104);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-radius: 8px;
  padding: 10px 20px;
  cursor: pointer;
}
.mobile .index {
  width: 100vw;
  height: 100vh;
  padding: 15px;
}
.mobile .menu-bg {
  padding: 10px;
}
.mobile .menu {
  width: 92vw;
  padding: 10px;
}
.mobile .menu-content {
  font-size: 12px;
}
.mobile .menu-button {
  font-size: 12px;
  padding: 8px 14px;
}
.mobile .lesson-img {
  width: 40px;
  height: 40px;
}
.mobile .lesson-name {
  font-size: 16px;
}
.mobile .lesson-desc {
  font-size: 14px;
}
.mobile .title {
  margin-bottom: 20px;
  font-size: 20px;
}
.mobile .tab {
  width: 100vw;
}
.tab {
  width: 550px;
  height: 40px;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #ecdff5;
  border-top: 1px solid #dfdfdf;
}
.tab-item {
  width: 33%;
  flex-grow: 1;
  border-right: 1px solid #d7d7d7;
  height: 25px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #999;
  cursor: pointer;
}
.tab-item:last-of-type {
  border-right: none;
}
.active {
  font-weight: 600;
  color: #333;
}
</style>
